// APPAUTH-001: session token helpers without axios (safe to import from any component and from tests).
const KEY = "token"
export const BACKEND_URL = (process.env.REACT_APP_API_URL || "http://localhost:8000").replace(/\/?api\/?$/i, "").replace(/\/+$/, "")

export function getToken() {
  try { return localStorage.getItem(KEY) } catch (e) { return null }
}

export function setToken(token) {
  try { localStorage.setItem(KEY, token) } catch (e) { /* storage blocked: session lasts for this page only */ }
}

export function clearToken() {
  try { localStorage.removeItem(KEY) } catch (e) { /* ignore */ }
}

export function isBackendUrl(url) {
  if (!url) return false
  return url.startsWith(BACKEND_URL) || url.startsWith("/api")
}

export function withToken(url) {
  const token = getToken()
  if (!token) return url
  return `${url}${url.includes("?") ? "&" : "?"}access_token=${encodeURIComponent(token)}`
}
